import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barcodes: []
  },
  mutations: {
    addBarcode (state, code) {
      state.barcodes.push(code);
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    getBarcodes: state => {
      return state.barcodes;
    }
  }
})
